var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":""}},[_c('b-modal',{ref:"downloadModal",attrs:{"centered":"","hide-footer":"","hide-header":""}},[_c('div',[_c('h4',{staticClass:"primary-color"},[_vm._v(_vm._s(_vm.$t("DownloadModal.title")))]),_c('ContactForm',{attrs:{"downloadUrl":_vm.downloadUrl,"closeModal":_vm.closeModal}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }